import React, { createContext, useContext, useEffect, useState } from "react";
import { db } from "../firebase";
import { ref, get, set } from "firebase/database";

const AppSettingsContext = createContext();

export function useAppSettings() {
  return useContext(AppSettingsContext);
}

export const DEFAULT_SETTINGS = {
  features: {
    listings: true,
    swap: true,
    notes: true,
    lostFound: true,
    rideshare: true,
    events: true,
    tutoring: true,
    requests: true,
    giveaway: true,
    noticeBoard: true,
    parentZone: true,
  },
  maintenance: false,
  maintenanceMessage: "We're improving CampusSwap. Back soon!",
  welcomeMessage: "",
  appVersion: "1.0.0",
};

export async function saveAppSettings(settings) {
  await set(ref(db, "appSettings"), settings);
}

export function AppSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [loadingSettings, setLoadingSettings] = useState(true);

  useEffect(() => {
    async function fetchSettings() {
      try {
        const snap = await get(ref(db, "appSettings"));
        if (snap.exists()) {
          const data = snap.val();
          setSettings({
            ...DEFAULT_SETTINGS,
            ...data,
            features: { ...DEFAULT_SETTINGS.features, ...(data.features || {}) },
          });
        }
      } catch (e) {
        
      }
      setLoadingSettings(false);
    }
    fetchSettings();
  }, []);

  if (loadingSettings) return null;

  if (settings.maintenance) {
    return (
      <div className="min-h-screen bg-blue-600 flex items-center justify-center p-6 text-center">
        <div className="text-white">
          <div className="text-6xl mb-4">🔧</div>
          <h1 className="text-2xl font-bold mb-2">Under Maintenance</h1>
          <p className="text-blue-200">{settings.maintenanceMessage}</p>
        </div>
      </div>
    );
  }

  return (
    <AppSettingsContext.Provider value={{ settings, setSettings }}>
      {children}
    </AppSettingsContext.Provider>
  );
}
